<template>
  <div class="mb-14">
    <BaseTitle :pageTitle="pageTitle" :hasBackButton="false" />
    <validation-observer ref="observer" v-slot="{ invalid, handleSubmit }">
      <form @submit.prevent="handleSubmit(submit)">
        <v-card>
          <v-tabs v-model="tab">
            <v-tab v-if="registrationCondition()" href="#tab-cadastro"
              >Cadastro</v-tab
            >
            <v-tab v-if="!passwordCondition()" href="#tab-perfil"
              >Perfil e Acesso</v-tab
            >
            <v-tab v-if="passwordCondition()" href="#tab-password"
              >Usuário e Senha</v-tab
            >
          </v-tabs>
          <v-tabs-items v-model="tab">
            <v-tab-item value="tab-cadastro">
              <register
                :loading="loading"
                :register="form"
                :view="view"
                :hasPermissionToEdit="hasPermissionToEdit()"
                @setFields="setFields"
              />
            </v-tab-item>
            <v-tab-item value="tab-perfil">
              <profile
                :loading="loading"
                :profile="form"
                :features="features"
                :actions="actions"
                :view="view"
                @setFields="setFields"
              />
            </v-tab-item>
            <v-tab-item value="tab-password">
              <password
                :loading="loading"
                :password="form"
                :view="view"
                @setFields="setFields"
              />
            </v-tab-item>
          </v-tabs-items>
        </v-card>
        <div class="button-field pa-3" v-if="!hide">
          <v-row justify="center">
            <v-col cols="auto">
              <v-btn
                large
                rounded
                class="pr-15 pl-15 elevation-0"
                @click="$router.go(-1)"
              >
                <span
                  class="icon-double-arrow-left"
                  style="margin-right: 10px"
                ></span>
                VOLTAR
              </v-btn>
            </v-col>
            <v-col cols="auto">
              <v-btn
                v-if="!view"
                :disabled="invalid"
                large
                rounded
                @click="validate()"
                color="primary"
                class="pr-15 pl-15 elevation-0"
              >
                SALVAR
              </v-btn>
            </v-col>
          </v-row>
        </div>
      </form>
    </validation-observer>
  </div>
</template>
<script>
import store from "../../_store";
import _ from "lodash";
import moment from "moment";
import { extend, ValidationObserver, setInteractionMode } from "vee-validate";
import { required } from "vee-validate/dist/rules";

import BaseTitle from "../../../../components/UI/BaseTitle.vue";
import Profile from "./profile.vue";
import Register from "./register.vue";
import Password from "./password.vue";

import { mapActions, mapGetters } from "vuex";
setInteractionMode("eager");

extend("required", {
  ...required,
  message: "Favor informar {_field_}."
});

export default {
  components: {
    BaseTitle,
    Profile,
    Register,
    ValidationObserver,
    Password
  },

  data: () => ({
    loading: false,
    pageTitle: "",
    hide: false,
    tab: "",
    features: [],
    actions: [],
    form: {}
  }),

  computed: {
    ...mapGetters({
      me: "$_auth/me",
      user: "$_user/user"
    }),
    view() {
      return this.$route.name == "users.view" || !this.$can("edit");
    }
  },

  beforeCreate() {
    const STORE_USER = "$_user";
    if (!(STORE_USER in this.$store._modules.root._children))
      this.$store.registerModule(STORE_USER, store);
  },
  async created() {
    this.checkRoute();

    let getuser = undefined;
    if (this.$route.name !== "users.create") {
      if (!this.$route.params.userId) {
        this.$route.params.userId = this.me.id;
        getuser = this.getuser(this.me.id);
      } else getuser = this.getuser(this.$route.params.userId);
    }

    this.loading = true;

    const result = await Promise.all([
      this.getFeatures(),
      this.getActions(),
      getuser
    ]);

    if (this.$route.name !== "users.create") this.form = this.user;

    this.features = result[0];
    this.actions = result[1];
    this.loading = false;
  },

  methods: {
    ...mapActions({
      storeUser: "$_user/store",
      getuser: "$_user/show",
      updateUser: "$_user/update",
      getFeatures: "$_auth/getFeatures",
      getActions: "$_auth/getActions",
      meRegister: "$_user/meRegister"
    }),

    setFields(items) {
      this.form = { ...this.form, ...items.data };
    },

    async validate() {
      if (!_.hasIn(this.form, "status")) {
        this.tab = "tab-perfil";
        return;
      }

      if (this.me.id !== this.$route.params.userId) {
        if (!moment(this.form.end_validity).isAfter(this.form.start_validity)) {
          await this.$store.dispatch(`$_messages/setErrors`, {
            message: `A data de validade do acesso final deve ser maior que a data de validade do acesso inicial.`,
            type: "error",
            title: "Error!",
            timeout: 8000
          });
          return;
        }

        if (this.form.permissions.length == 0) {
          await this.$store.dispatch(`$_messages/setErrors`, {
            message: "Insira ao menos uma permissão para o usuário.",
            type: "error",
            title: "Error!",
            timeout: 8000
          });

          return;
        }
      }

      await this.$store.dispatch("$_notifications/setAlert", {
        message: "Deseja salvar as alterações do usuário?",
        cancelTitle: "Não",
        actions: [
          {
            title: "Sim",
            action: this.send
          }
        ]
      });
    },

    async send() {
      if (this.form.employee_number) {
        this.form.employee_number = this.form.employee_number.replace(
          /[^0-9]/g,
          ""
        );
      }
      if (this.form.phone_number) {
        this.form.phone_number = this.form.phone_number.replace(/[^0-9]/g, "");
      }
      this.form.provider_id = this.me.providers[0].id;

      try {
        var result = "OK";
        if (!this.$route.params.userId) {
          result = await this.storeUser(this.form);
        } else if (this.me.id == this.$route.params.userId) {
          result = await this.meRegister(this.form);
        } else {
          result = await this.updateUser({
            id: this.$route.params.userId,
            body: this.form
          });
        }
        await this.$store.dispatch(`$_messages/setErrors`, {
          message: result.message,
          type: "success",
          title: "Success!",
          timeout: 12000
        });
        this.$router.go(-1);
      } catch (error) {
        await this.$store.dispatch(`$_messages/setErrors`, {
          message: error.response.data.message,
          type: "error",
          title: "Success!",
          timeout: 12000
        });
      }
    },

    checkRoute() {
      const { name } = this.$route;

      switch (name) {
        case "users.create":
          this.pageTitle = "CADASTRAR USUÁRIO DO FORNECEDOR";
          break;
        case "users.edit":
          this.pageTitle = "ALTERAR USUÁRIO DO FORNECEDOR";
          break;
        case "users.view":
          this.pageTitle = "VISUALIZAR USUÁRIO DO FORNECEDOR";
          break;
      }
    },

    passwordCondition() {
      if (this.$route.params.userId && this.$route.params.userId == this.me.id)
        return true;
      return false;
    },

    registrationCondition() {
      if (
        this.$route.params.userId &&
        this.$route.params.userId == this.me.id &&
        !this.me.employee_number
      )
        return false;
      return true;
    },

    hasPermissionToEdit() {
      if (this.$route.name === "user.index") return true;
      else return false;
    }
  }
};
</script>

<style lang="scss">
.button-field {
  z-index: 1;
  background-color: #c4c4c4b0;
  position: fixed;
  width: 100%;
  left: 0px;
  bottom: 0;
}
</style>
